<ion-header>
    <ion-toolbar class="header-color">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title class="toolbar-title">Log in</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="login-wr">
              <div *ngIf="this.authService.loginSourceError" class="login-source-error">
                <span (click)="onCloseExistingSourceError()">
                  <ion-icon name="close"></ion-icon>
                </span>
                <p> {{this.authService.loginSourceError}} </p>
              </div>
              <div class="text-center login-btn-wr">
                <div *ngIf="this.authService.showFacebookLogin">
                  <ion-button expand='block' color="google" class="facebook" (click)="fbLogin()">
                      <svg width="40" height="40" viewBox="0 0 36 36" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><path d="m32 16c0-8.839-7.167-16-16-16-8.839 0-16 7.161-16 16 0 7.984 5.849 14.604 13.5 15.803v-11.177h-4.063v-4.625h4.063v-3.527c0-4.009 2.385-6.223 6.041-6.223 1.751 0 3.584.312 3.584.312v3.937h-2.021c-1.984 0-2.604 1.235-2.604 2.5v3h4.437l-.713 4.625h-3.724v11.177c7.645-1.199 13.5-7.819 13.5-15.803z"/></svg>
                      <p>Continue with Facebook</p>
                  </ion-button>
                </div>
                  <div *ngIf="this.authService.showGoogleLogin">
                  <ion-button expand='block' color="facebook" class="google" (click)="googleLogin()">
                      <svg width="36" height="36" viewBox="0 0 40 40"><g fill="none" fill-rule="evenodd"><rect width="40" height="40" fill="#FFF" rx="3.2"></rect><path fill="#D7282A" d="M7.54 12.984c.582-1.299 1.405-2.432 2.37-3.457 2.185-2.32 4.83-3.806 7.96-4.313 4.382-.71 8.303.337 11.692 3.295.215.187.267.296.035.527-1.197 1.187-2.374 2.394-3.558 3.593-.122.124-.204.274-.42.073-2.983-2.77-7.853-2.739-11.024.25-1.088 1.025-1.862 2.255-2.369 3.664-.074-.049-.152-.093-.221-.147-1.49-1.16-2.978-2.323-4.466-3.485"></path><path fill="#45AC43" d="M12.19 22.275c.429 1.101.96 2.142 1.75 3.026 2.009 2.248 4.498 3.218 7.481 2.904 1.386-.146 2.65-.621 3.829-1.352.113.102.221.212.34.306 1.381 1.093 2.764 2.183 4.146 3.274-1.524 1.468-3.324 2.444-5.348 2.963-4.773 1.223-9.173.45-13.08-2.675a13.408 13.408 0 0 1-3.78-4.776l4.663-3.67"></path><g transform="translate(20.192 16.688)"><path fill="#4385F5" d="M9.544 13.746C8.162 12.655 6.78 11.564 5.4 10.472c-.12-.095-.228-.205-.34-.307.935-.724 1.716-1.58 2.229-2.668.204-.434.348-.887.484-1.346.094-.317.065-.44-.322-.437-2.3.02-4.6.01-6.901.01-.488 0-.488 0-.488-.51 0-1.581.007-3.162-.007-4.742C.052.167.104.05.443.052c4.243.012 8.486.009 12.73.003.229 0 .373.017.413.3.527 3.76.104 7.355-1.838 10.674-.595 1.016-1.31 1.944-2.204 2.717"></path></g><path fill="#F4C300" d="M12.19 22.275l-4.663 3.67c-.759-1.43-1.197-2.967-1.4-4.568-.355-2.773.034-5.441 1.195-7.986.064-.14.144-.271.217-.407l4.466 3.485c.07.054.147.098.221.147-.624 1.883-.592 3.77-.035 5.66"></path></g></svg>
                      <p>Continue with Google</p>
                  </ion-button>
                </div>
              </div>
            <div class="email-login-section" *ngIf="this.authService.showPromogaLogin">
              <div class="text-center">
                  <div class="divider-alt text-center ui-or">
                      <span>Email Login</span>
                  </div>
              </div>
              <div class="ion-text-left form-wr">
                  <form [formGroup]="loginForm" (ngSubmit)="submitForm()" novalidate>
                      <ion-item class="inputStyle">
                          <ion-input
                                  type="text"
                                  formControlName="email"
                                  placeholder="Email Address"
                                  required>
                          </ion-input>
                      </ion-item>

                      <ion-item class="inputStyle">
                          <ion-input
                                  type="password"
                                  formControlName="password"
                                  placeholder="Password"
                                  required>
                          </ion-input>
                      </ion-item>
                      <p *ngIf="this.loginForm.controls['email'].errors && this.loginForm.controls['email'].dirty" class="error" padding>Please enter a valid email address.</p>
                      <p *ngIf="this.loginForm.controls['password'].errors && this.loginForm.controls['password'].dirty" class="error" padding>Please enter a valid password.</p>

                      <p class="padding-bottom padding-top">
                          <ion-checkbox [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}"></ion-checkbox>
                          <ion-label class="term-label">Remember Me</ion-label>
                      </p>

                  <ng-container *ngIf="this.loginForm.valid">
                        <ion-button
                                class="login-button"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="false"
                        >
                            Log in
                        </ion-button>
                    </ng-container>
                    <ng-container *ngIf="!this.loginForm.valid">
                        <ion-button
                                class="login-button"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="true"
                        >
                            Log in
                        </ion-button>
                    </ng-container>

                      <p class="text-center"><a (click)="onForgotPassword()">Forgot Password</a></p>
                  </form>
              </div>
            </div>
              <div class="text-center padding-vertical">
                <div class="padding-top signup">
                  Not in the Promoga Community yet? <a (click)="onClickSignup()">Sign up</a>
                </div>
              </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
